<app-page-header></app-page-header>
<!-- Single Candidate Start -->
<section class="single-candidate-page section_70">
  <div class="container">
    <div class="row" *ngIf="showDetails">
      <div class="col-md-9 col-lg-6">
        <div class="single-candidate-box">
          <div class="single-candidate-box-right">
            <h4>{{vacancy.title}} </h4>
            <div class="job-details-meta">
              <!--              <p><i class="fa fa-file-text"></i> Applications N/</p>-->
              <p><i class="fa fa-calendar" id="cdate"></i> Closing Date: {{vacancy.closingDate}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-lg-6">
        <div class="single-candidate-box">
          <div class="single-candidate-box-right">
            <h4>Reference Number : {{vacancy.referenceNumber}}</h4>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="!showDetails">
      <div class="col-md-3 col-lg-3">
        <div class="single-candidate-box">
          <div class="single-candidate-box-right">

          </div>
        </div>
      </div>
      <div class="col-md-4 col-lg-4">
        <div class="single-candidate-box">
          <div class="single-candidate-box-right">
            <h4>Vacancy does not exit ! </h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Single Candidate End -->


<!-- Single Candidate Bottom Start -->
<section class="single-candidate-bottom-area section_70" *ngIf="showDetails">
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-lg-9">
        <div class="single-candidate-bottom-left">
          <app-job-description [vacancy]="vacancy"></app-job-description>
        </div>
      </div>
      <div class="col-md-4 col-lg-3">
        <div class="single-candidate-bottom-right">
          <div class="single-candidate-widget-2" [hidden]="applied">
            <button [hidden]="applying" (click)="applyVacancy(vacancy.id)" class="btn btn-block jobguru-btn-2">
              <i class="fa fa-paper-plane-o"></i>
              Apply Now
            </button>
            <button [hidden]="!applying" class="btn btn-block jobguru-btn-2">
              <i class="fa fa-spinner fa-spin"></i>
              Applying vacant....
            </button>
          </div>
          <div class="single-candidate-widget-2">
            <h3>Job overview</h3>
            <ul class="job-overview">
              <li>
                <h4><i class="fa fa-briefcase"></i> open positions</h4>
                <p>{{vacancy.numberOfApplicants}}</p>
              </li>
              <li>
                <h4><i class="fa fa-map-marker"></i> Location</h4>
                <p>{{vacancy.location}}</p>
              </li>
              <!-- <li>
                <h4><i class="fa fa-thumb-tack"></i> Job Type</h4>
                <p>{{vacancy.contractType}}</p>
              </li> -->
              <li>
                <!-- fa fa-fw fa-lg svg-inline--fa fa-hourglass-half fa-w-12 -->
                <h4><i class="fa fa-hourglass-half"></i>Job Status </h4>
                <p>{{vacancy.jobStatus}}</p>
              </li>
              <li>
                <h4><i class="fa fa-calendar"></i> Date Posted</h4>
                <p>{{vacancy.publishDate | date}}</p>
              </li>
              <li>
                <h4><i class="fa fa-calendar" id="cdate"></i> Closing date</h4>
                <p>{{vacancy.closingDate | date}}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Single Candidate Bottom End -->
